import { FormGroup } from "@material-ui/core"
import { useState } from "react"
import { useHistory } from "react-router-dom"
import { Button } from "../../components/button"
import { BackButton } from "../../components/buttons/back_btn"
import CheckboxCard from "../../components/checkbox_card"
import { BaseContainer } from "../../components/container"
import { InfoBox } from "../../components/info_box"
import { HeaderTitle, PageDescription } from "../../components/page_sections"
import { StickyFooterGroup } from "../../components/sticky_footer_group"
import { TwoLineText } from "../../components/two_line_text"
import Typography from "../../components/typography"

const SelectSharingUsers = (props) => {
    const [selected, setSelected] = useState([])
    const history = useHistory()

    // The account holder can share their own records as well as the dependants they manage.
    const profiles = []
    if (props.accountHolder?.uuid) {
        profiles.push({ ...props.accountHolder, isAccountHolder: true })
    }
    profiles.push(...props.dependants)

    const addToSharing = (event, dependant) => {
        const checked = event.target.checked
        if (checked) {
            setSelected(old => [...old, dependant])
        } else {
            setSelected(old => {
                const newArr = old.filter(dep => dep.uuid !== dependant.uuid)
                return newArr
            })
        }
    }

    return (
        <BaseContainer noHeader showCta extraComponent={
            <StickyFooterGroup>
                <Button fullWidth primary disabled={!selected.length}
                    onClick={() => {history.push('/sharing/send/email', {dependants: selected} )}}>
                    Share
                </Button>
                <Button fullWidth onClick={props.stopSharing}>
                    Cancel
                </Button>
            </StickyFooterGroup>
        }>

            <BackButton onClick={props.stopSharing}/>

            <HeaderTitle>
                Select profile to share
            </HeaderTitle>

            <PageDescription>
                <Typography variant="bodyTextLarge">
                    You can share ‘view only’ access to the records you manage with other trusted parties who have an Imunis account.
                </Typography>
            </PageDescription>

            <PageDescription>
                <InfoBox>
                    <Typography variant="bodyTextMediumDark">
                        Vaccination records contain sensitive personal healthcare information - please only share with parties you trust.
                    </Typography>
                </InfoBox>
            </PageDescription>

            <FormGroup>
                {profiles.map(profile => (
                    <CheckboxCard
                        key={profile.uuid}
                        label={
                            <TwoLineText>
                                <Typography variant="bodyTextLargeBold">
                                    {profile.preferred_name}
                                </Typography>
                                {profile.isAccountHolder && (
                                    <Typography variant="bodyTextSmall">
                                        Your own records
                                    </Typography>
                                )}
                            </TwoLineText>
                        }
                        value={profile.uuid}
                        onChange={(e) => addToSharing(e, profile)}
                    />
                ))}
            </FormGroup>

        </BaseContainer>
    )
}

export default SelectSharingUsers
